import React, { useRef, useState } from "react";
import { Avatar, Box, Divider, Typography } from "@material-ui/core";
import {
  CustomCard,
  CustomMenu,
  DeleteConfirmationDialog,
} from "../../../../../../../../Components";
import { getDownloadableLink } from "../../../../../../../../Helper";
import {
  useQuery,
  useSelectedTheme,
  useTranslate,
} from "../../../../../../../../Hooks";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { PropertyImagePreviewDialog } from "../PropertyImagePreviewDialog";
import { EditPropertyImageDialog } from "../EditPropertyImageDialog";
import { DeletePropertyImagesCategory } from "../../../../../../../../Services";
import { useVerticalNav } from "../../../../../../../../Contexts/VerticalNavContext";
// styles
import useStyles from "./styles";

// Icons
import {
  Edit3Icon,
  Image01Icon,
  MoreVertIcon,
  TrashOne,
} from "../../../../../../../../assets/icons";

function PropertyImageCard({ data, setRefetchDataPropertyImage }) {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();
  const splideRef = useRef();
  const query = useQuery();
  const { setAlertBoxContent } = useVerticalNav();
  const [isPreviewImageDialogOpen, setIsPreviewImageDialogOpen] =
    useState(false);
  const [activeImage, setActiveImage] = useState(null);
  const [isEditImageDialogOpen, setIsEditImageDialogOpen] = useState(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const deleteHandler = async () => {
    const res = await DeletePropertyImagesCategory(
      data.categoryId,
      Number(query.get("id"))
    );
    if (!(res && res.status && res.status !== 200)) {
      setAlertBoxContent({
        display: true,
        variant: "success",
        title: translate("categry-deleted-successfully"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
      setRefetchDataPropertyImage(true);
    } else {
      const errorMessage = (res && res.data && res.data.Message).split(": ")[1];
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate(`${errorMessage}`),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    }
  };

  return (
    <>
      <CustomCard
        borderRadius="md"
        borderColor="secondary"
        classes={styles.containerPropertyCard}
        onClick={() => {
          const currentIndex = splideRef.current?.splide?.index ?? 0;
          const currentVideo = data?.images?.result?.filter(
            (img) => img.fileId
          )?.[currentIndex];
          if (currentVideo) {
            setActiveImage(currentVideo);
          }
          setIsPreviewImageDialogOpen(true);
        }}
      >
        <Box
          className={styles.containerHeaderCard}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Box className={styles.splideWrapper}>
            <Splide
              className={styles.paginationDot}
              aria-label="Videos"
              options={{
                classes: { arrows: "splide__arrows details-tab-arrows" },
                start: 0,
                pagination: true,
              }}
              ref={splideRef}
            >
              {data?.images?.result
                ?.filter((vid) => vid.fileId)
                .map((imageItem) => (
                  <SplideSlide
                    key={imageItem.fileId}
                    className={styles.splideSlide}
                  >
                    <Box
                      className={styles.wrapperVideo}
                      onClick={(e) => {
                        setActiveImage(imageItem);
                        setIsPreviewImageDialogOpen(true);
                      }}
                    >
                      <img
                        src={getDownloadableLink(imageItem.fileId)}
                        width="100%"
                        height="100%"
                        className={styles.videoHover}
                      />
                    </Box>
                  </SplideSlide>
                ))}
            </Splide>
          </Box>
        </Box>
        <Box className={styles.containerBodyCard}>
          <Box className={styles.sectionMnueCategoryName}>
            <Typography className={styles.containerCategoryName}>
              {data?.categoryName}
            </Typography>
            <CustomMenu
              menuItems={[
                {
                  icon: (
                    <Edit3Icon
                      width="16"
                      height="16"
                      fill={palette.button.secondaryGray_fg}
                    />
                  ),
                  text: "Edit",
                  handler: () => {
                    const currentIndex = splideRef.current?.splide?.index ?? 0;
                    const currentImage = data?.images?.result?.filter(
                      (img) => img.fileId
                    )?.[currentIndex];
                    if (currentImage) {
                      setActiveImage(currentImage);
                      setIsEditImageDialogOpen(true);
                    }
                  },
                },
                {
                  icon: (
                    <TrashOne
                      width="16"
                      height="16"
                      fill={palette.button.secondaryGray_fg}
                    />
                  ),
                  text: "Delete",
                  handler: () => {
                    setIsDeleteDialogOpen(true)
                  },
                },
              ]}
              activeIconClass={styles.menuActiveIconClass}
              defaultIconClass={styles.menuDefaultIconClass}
            >
              <MoreVertIcon width="20" height="20" />
            </CustomMenu>
          </Box>
          <Box className={styles.sectionCreatedBy}>
            <Box className={styles.containerItemAvatar}>
              <Avatar
                className={styles.AvatarStyle}
                src={"/images/contacts/MaleAvatar.svg"}
              ></Avatar>
            </Box>
            <Box className={styles.containerCreatedBy}>
              <Typography className={styles.createdByValue}>
                {data?.createdBy}
              </Typography>
              <Typography className={styles.createdByTitle}>
                {translate("Created-by")}
              </Typography>
            </Box>
          </Box>
          <Divider />
          <Box className={styles.containerInfoProprety}>
            <Box className={styles.containerCountImages}>
              <Image01Icon
                width="20"
                height="20"
                fill={palette.utility.utility_gray_400}
              />
              <Typography className={styles.totalCountValue}>
                {data?.images?.totalCount}
              </Typography>
            </Box>
          </Box>
        </Box>
      </CustomCard>
      {isPreviewImageDialogOpen && (
        <PropertyImagePreviewDialog
          onOpen={isPreviewImageDialogOpen}
          onClose={() => {
            setIsPreviewImageDialogOpen(false);
          }}
          data={data}
          activeImage={activeImage}
        />
      )}
      {isEditImageDialogOpen && (
        <EditPropertyImageDialog
          open={isEditImageDialogOpen}
          onClose={() => setIsEditImageDialogOpen(false)}
          data={data}
          activeImage={activeImage}
          setRefetchDataPropertyImage={setRefetchDataPropertyImage}
        />
      )}

      {isDeleteDialogOpen && (
        <DeleteConfirmationDialog
          onClose={() => {
            setIsDeleteDialogOpen(false);
          }}
          title={translate("Your-Category-will-be-deleted")}
          subTitle={translate(
            "Are-you-sure-you-want-to-delete-this-Category-This-action-cannot-be-undone"
          )}
          onConfirm={() => {
            deleteHandler();
            setIsDeleteDialogOpen(false);
          }}
          confirmText={translate("Delete")}
        />
      )}
    </>
  );
}

export default PropertyImageCard;
